<template>
  <div :class="request_prefix === 'bigScreen' ? 'bigScreen' : ''">
    <div
      :class="filedMapping.flag && filedMapping.value ? 'mapping_content checked' : 'mapping_content'"
    >
      <div class="verticallyBetweenCenter">
        <div class="content-title">
          {{ getValueByTypeHandle(options.innerElement) }}
        </div>
        <div class="verticallyCenter" v-if="!filedMapping.isDate && (options.innerElement=='cxText' || options.innerElement=='cxButton' || options.innerElement=='cxLabel')">
          <el-checkbox v-model="options.isHyperlink">超链接</el-checkbox>
          <el-tooltip popper-class="maxWidth160" placement="top" :open-delay="1000" content="勾选后，会出现链接地址配置项，可关联数据源链接字段"><i class="tips-btn icon-portal-info2"></i></el-tooltip>
        </div>
      </div>
      <div class="select_content mt8">
        <el-select
          style="width: 100%"
          v-model="filedMapping.value"
          @change="
            changeFiledMappingHandle(
              $event,
              {
                elementInLayoutId: options.elementInLayoutId,
                elementInAutoLayoutId: options.elementInAutoLayoutId,
                path: options.path,
                flag: 'value'
              },
              true
            )
          "
          placeholder="请选择"
          clearable
        >
          <el-option v-for="(item, index) in fieldMappingList" :key="index" :label="item.label" :value="item.value">
            <span style="font-size: 13px">{{ item.label }}</span>
          </el-option>
        </el-select>
      </div>
      <div
        class="verticallyCenter mapping_date_content mt8"
        v-if="filedMapping.flag && !filedMapping.isDate && (options.innerElement === 'cxText' || options.innerElement === 'cxLabel')"
      >
        <label class="date-label">显示为:</label>
        <el-dropdown trigger="click" @command="onChangeMappingType">
          <span class="el-dropdown-link">
            {{ fieldMappingDataTypeName }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" :class="request_prefix === 'bigScreen' ? 'bigScreen custom-dropdown' : 'custom-dropdown'">
            <el-dropdown-item v-for="item in dataTypeList" :key="item.value" :command="item.value">
              <div :class="filedMapping.dataType === item.value ? 'dropdown-item active' : 'dropdown-item'">
                {{ item.label }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="verticallyCenter mapping_date_content mt8" v-if="filedMapping.flag && filedMapping.isDate && !['cxVideo'].includes(options.innerElement)">
        <label class="date-label">显示为:</label>
        <el-dropdown trigger="click" @command="onChangeMappingDateStyle">
          <span class="el-dropdown-link">
            {{ fieldMappingDateStyle }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" :class="request_prefix === 'bigScreen' ? 'bigScreen custom-dropdown' : 'custom-dropdown'">
            <div class="dropdown-title-show">
              <cx-check-box :value.sync="filedMapping.dateTitle" @change="onChangeMappingDateTitle">显示字段名</cx-check-box>
            </div>
            <el-dropdown-item v-for="item in dateOptions" :key="item.value" :command="item.value">
              <div :class="filedMapping.dateStyle === item.value ? 'dropdown-item active' : 'dropdown-item'">
                {{ item.label }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div v-if="options.innerElement == 'cxVideo' || options.innerElement == 'cxAudio'" class="vedio-style mt8">
        <el-checkbox v-model="options.videoObjectId"></el-checkbox><label>支持云盘</label>
      </div>
      <div class="select_content mt8" v-if="filedMapping.flag && options.isHyperlink">
        <el-select
          style="width: 100%"
          v-model="filedMapping.linkUrl"
          @change="
            changeFiledMappingHandle(
              $event,
              {
                elementInLayoutId: options.elementInLayoutId,
                elementInAutoLayoutId: options.elementInAutoLayoutId,
                path: options.path,
                flag: 'linkUrl'
              },
              true
            )
          "
          placeholder="请选择"
          clearable
        >
          <el-option v-for="(item, index) in fieldMappingList" :key="index" :label="item.label" :value="item.value">
            <span style="font-size: 13px">{{ item.label }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="verticallyCenter mt4" v-if="options.isHyperlink">
        <el-checkbox v-model="options.openBlankPage">新页面打开</el-checkbox>
      </div>
    </div>
    <div class="mt16" v-if="showEmptyData && options.innerElement === 'cxText'">
      <cx-check-box :value.sync="emptyDataShowLocal">
        <span>数据为空时显示以下内容</span>
        <el-tooltip
          popper-class="width200"
          effect="dark"
          content="勾选后，数据源返回内容为空时，组件显示你所设置的样式及内容，未勾选，数据源返回内容为空时，组件不显示"
          placement="top"
          :open-delay="1000"
        >
          <span class="tips-btn icon-portal-info2"></span>
        </el-tooltip>
      </cx-check-box>
      <div v-if="emptyDataShowLocal">
        <div class="mt16 text_content" v-if="!searchComponentPlugin">
          <span>文字样式</span>
          <!-- 字体和颜色/字重和字号 -->
          <text-setting-update
            class="mb16 mt6 nextlinemt8"
            :fontColor.sync="emptyFontColor"
            :fontFamily.sync="emptyFontFamily"
            :fontSize.sync="emptyFontSize"
            :fontWeight.sync="emptyFontWeight"
          />
        </div>
        <el-input class="mt8" v-model="emptyContent" placeholder="请输入" type="text"></el-input>
      </div>
      <cx-check-box v-if="isBigScreen" class="mt8" :value.sync="showEditCacheValue">显示编辑页缓存值</cx-check-box>
    </div>
    <div class="mt16" v-if="showEmptyData && options.innerElement === 'imageComponent'">
      <cx-check-box :value.sync="emptyDataShowLocal">
        <span>数据为空时显示以下图片</span>
        <el-tooltip
          popper-class="width200"
          effect="dark"
          content="勾选后，数据源为空时，图片组件显示你所配置的内容，未勾选，数据源为空时，图片组件显示默认图片样式"
          placement="top"
          :open-delay="1000"
        >
          <span class="tips-btn icon-portal-info2"></span>
        </el-tooltip>
      </cx-check-box>
      <div v-if="emptyDataShowLocal" class="mt12">
        <img-upload
          :imgSrc.sync="emptyImgSrc"
          imgType="12"
          :defaultImg="defaultImgBg"
          :showDel="false"
          size="medium"
          :showSize="false"
        ></img-upload>
      </div>
    </div>
  </div>
</template>

<script>
import { getValueByType, isExist, getAllColsUidInLayoutComponent } from "utils"
import { UpdateLayoutData } from "utils/updateData/layout/layoutComponentUpdateData.js"
import { getAppointCacheData } from "utils/updateData/publicDataUtils/getRestClassify.js"
import { UpdateData } from "utils/updateData/swiper/swiperComponentUpdateData.js"
import defaultImgBg from "assets/images/empty_img_bg.png"
import { TYPE_FIELD_MAPPING } from "consts" 
export default {
  name: "colsFieldMappingSetting",
  components: {},
  mixins: [],
  props: {
    ids: {
      type: Object
    },
    myId: {
      type: Object
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      dataTypeList: [
        {
          label: "字段名称：字段内容",
          value: "dataKey"
        },
        {
          label: "字段内容",
          value: "dataValue"
        },
        {
          label: "字段名称",
          value: "dataName"
        }
      ],
      fieldMappingList: [],
      dateOptions: [
        {
          value: "7",
          label: "年-月-日 时:分:秒"
        },
        {
          value: "10",
          label: "年-月-日 时:分"
        },
        {
          value: "1",
          label: "年-月-日"
        },
        {
          value: "2",
          label: "年-月"
        },
        {
          value: "3",
          label: "月-日"
        },
        {
          value: "8",
          label: "时:分"
        },
        {
          value: "4",
          label: "年"
        },
        {
          value: "5",
          label: "月"
        },
        {
          value: "6",
          label: "日"
        },
        {
          value: "9",
          label: "文本格式"
        }
      ],
      defaultImgBg: defaultImgBg
    }
  },
  mounted() {
    console.log('this.layoutOptions.noCacheComponent :>>', this.layoutOptions.noCacheComponent);
    if (this.layoutOptions.noCacheComponent || this.hasGetDetailDataPlugin || this.isCxDataGrid) {
      this.getFiledMappingList()
    }
    if (this.isSearchListPage) {
      this.getSearchListData()
    }
    if (this.isGroupSearchListPage) {
      this.getGroupSearchListData()
    }
  },
  computed: {
    commitIds() {
      return this.myId || this.ids
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    showEmptyData() {
      return this.filedMapping?.flag && this.layoutOptions?.innerElement === "emptyLayoutComponent"
    },
    filedMapping() {
      return this.options?.filedMapping || {}
    },
    isSearchListPage() {
      return this.$store.state[this.request_prefix].page.pluginName?.includes("searchListPagePlugin") || false
    },
    isGroupSearchListPage() {
      return this.$store.state[this.request_prefix].page.pluginName?.includes("groupSearchListPagePlugin") || false
    },
    layoutOptions() {
      let rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids, "rect")?.options
      if (
        rectAttr &&
        isExist(this.ids.elementInAutoLayoutId) &&
        (isExist(this.ids.elementInLayoutId) || isExist(this.ids.elementInSwiperId) || isExist(this.ids.elementInDataGridId)) &&
        rectAttr.innerElement === "cxAutoLayout"
      ) {
        rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          ...this.ids,
          elementInLayoutId: undefined
        })
      }
      if (
        rectAttr &&
        rectAttr.pluginName &&
        (rectAttr.pluginName[0] == "loginLayoutComponent" || rectAttr.pluginName[0] === "loginEngineComponentPlugin")
      ) {
        return rectAttr
      }
      if (
        rectAttr &&
        rectAttr.innerElement !== "emptyLayoutComponent" &&
        rectAttr.innerElement !== "layoutComponent" &&
        rectAttr.innerElement !== "swiperComponent" &&
        rectAttr.innerElement !== "cxDataGrid"
      ) {
        return {}
      }
      return rectAttr
    },
    searchComponentPlugin() {
      return this.layoutOptions?.pluginName?.includes("searchComponentPlugin")
    },
    isTypeRenderMode() {
      return this.layoutOptions?.pluginName?.includes("renderTypeCol")
    },
    emptyDataShowLocal: {
      get() {
        return this.options.hasOwnProperty("emptyDataShowLocal") ? this.options.emptyDataShowLocal : false
      },
      set(newVal) {
        this.getFiledMappingList()
        this.$changeOptionsEV(newVal, "emptyDataShowLocal", false, null)
      }
    },
    emptyContent: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "emptyContent", "emptyContent", "")
      },
      set(newVal) {
        this.getFiledMappingList()
        this.$changeOptionsEV(newVal, "emptyContent", false, null)
      }
    },
    emptyFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "emptyFontFamily", "emptyFontFamily", "sans-serif")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyFontFamily", false)
      }
    },
    emptyFontSize: {
      get() {
        return this.options.emptyFontSize || 24
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyFontSize", false)
      }
    },
    emptyFontWeight: {
      get() {
        return this.options.emptyFontWeight || 400
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyFontWeight", false)
      }
    },
    emptyFontColor: {
      get() {
        return this.options.emptyFontColor || "rgba(0, 0, 0, 0.8)"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyFontColor", false)
      }
    },
    emptyImgSrc: {
      get() {
        return this.options.emptyImgSrc || ""
      },
      set(newVal) {
        this.getFiledMappingList()
        this.$changeOptionsEV(newVal, "emptyImgSrc", false)
      }
    },
    showEditCacheValue: {
      get() {
        return this.options.hasOwnProperty("showEditCacheValue") ? this.options.showEditCacheValue : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showEditCacheValue", false, null)
      }
    },
    isBigScreen() {
      return this.request_prefix === "bigScreen"
    },
    hasGetDetailDataPlugin() {
      return this.layoutOptions?.pluginName?.includes("getDetailDataPlugin")
    },
    fieldMappingDataType: {
      get() {
        return this.filedMapping?.dataType || "dataValue"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filedMapping.dataType", false, null, {
          ...this.commitIds
        })
      }
    },
    fieldMappingDataTypeName() {
      const item = this.dataTypeList.find(data => data.value === this.fieldMappingDataType)
      return item?.label || ""
    },
    fieldMappingDateStyle() {
      const item = this.dateOptions.find(data => data.value === this.filedMapping?.dateStyle)
      return item?.label || ""
    },
    dataType: {
      get() {
        return this.options.dataType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dataType", false, null, {
          ...this.commitIds
        }, true)
      }
    },
    fieldMappingClickStatus: {
      get() {
        return this.filedMapping?.clickStatus || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filedMapping.clickStatus", false, null, {
          ...this.commitIds
        })
      }
    },
    fieldMappingMessage: {
      get() {
        return this.filedMapping?.clickMessage || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filedMapping.clickMessage", false, null, {
          ...this.commitIds
        })
      }
    },
    isCxDataGrid() {
      return this.layoutOptions.innerElement === "cxDataGrid"
    }
  },
  methods: {
    getValueByTypeHandle(type) {
      return getValueByType(type)
    },
    async getAppointDataEv() {
      let rectAttr = this.layoutOptions
      const { websiteId, pageId, sign, wfwfid } = this.$store.state.states.getDataPageIds
      const appId = rectAttr.appId ? rectAttr.appId : rectAttr.myFetchParam.appId
      return await getAppointCacheData.call(
        this,
        pageId,
        wfwfid,
        websiteId,
        appId,
        { useSubPageQuery: rectAttr.useSubPageQuery, selectedDetailParam: rectAttr.selectedDetailParam }
      )
    },
    async getFiledMappingList() {
      let rectAttr = this.layoutOptions
      this.fieldMappingList = []
      if (this.isCxDataGrid) {
        this.getGridFiledMapping()
        return
      }
      if (this.searchComponentPlugin) {
        const { appId, activeSearchData } = this.layoutOptions
        if (appId) {
          this.completeData = [activeSearchData]
          Object.keys(activeSearchData).forEach(key => {
            if (key === "name" || key === "des") {
              const temp = {
                value: key,
                label: key === "name" ? "名称" : key === "des" ? "说明" : ""
              }
              this.fieldMappingList.push(temp)              
            }
          })
          if (this.options.innerElement === 'cxText') {
            let value = activeSearchData[this.filedMapping?.value] || ""
            const name = this.filedMapping?.value === "name" ? "名称" : this.filedMapping?.value === "des" ? "说明" : ""
            switch (this.fieldMappingDataType) {
              case "dataKey":
                value = name + "：" + value
                break
              case "dataName":
                value = name
                break
            }
            this.$changeOptionsEV(value, "content", false, null, {
              ...this.commitIds
            }, true)
          }
        }
        //搜索数据源
        this.dataType = "3"
        return
      }
      this.dataType = ""
      const dataPageIds = this.$store.state.states.getDataPageIds
      console.log("dataPageIds :>>", dataPageIds)
      const { typeId, typeIds, relIds, isOr } = dataPageIds
      let { cacheDataTypes, restDataUrl, generalDataTypes } =
        (!this.hasGetDetailDataPlugin && (await this.getAppointDataEv())) || {}
      let { activeIndex } = rectAttr
      let updateLayoutData = {}
      let newCompleteData = [],
        newDrawLayoutAlready = {}
      if (rectAttr.innerElement === "swiperComponent") {
        activeIndex = this.ids.swiperContent_id
        const updateCb = (val, content_name, deep, deepName, ids) => {
          this.$changeOptionsEV(val, content_name, deep, deepName, ids, true)
        }
        updateLayoutData = new UpdateData(this)
        ;[newDrawLayoutAlready, newCompleteData] = await updateLayoutData.upDateRect(
          rectAttr,
          cacheDataTypes,
          restDataUrl,
          {
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id,
            elementInAutoLayoutId: this.layoutOptions.elementInAutoLayoutId,
            path: this.layoutOptions.path
          },
          updateCb
        )
      } else {
        updateLayoutData = new UpdateLayoutData(this)
        const { completeData, drawLayoutAlready } = await updateLayoutData.upDateRect({
          activeIndex,
          rectAttr,
          cacheDataTypes,
          renderModel: this.isTypeRenderMode ? 'type' : 'data',
          wholeDataTypes: generalDataTypes,
          restDataUrl,
          typeId,
          typeIds,
          relIds,
          isOr,
          ids: {
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id,
            elementInAutoLayoutId: this.layoutOptions.elementInAutoLayoutId,
            path: this.layoutOptions.path
          },
          categoryMode: rectAttr?.options?.categoryMode || rectAttr?.categoryMode,
          addCb: param => {
            this.$store.dispatch(this.request_prefix + "/addComponentInLayout", param)
          },
          hideComponentCb: (param, opacity, display) => {
            if (!opacity && !display) {
              // 把透明度重置为1
              param.option_name = "opacity"
              param.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
            }
            param.option_name = "display"
            param.option_val = "none"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
          },
          showComponentCb: (param, opacity, display) => {
            if (opacity === 0 && !display) {
              // 把透明度重置为1
              param.option_name = "opacity"
              param.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
            }
            param.option_name = "display"
            param.option_val = "block"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
          },
          updateCb: (completeParam, opacity, display) => {
            let completeParamClone = Object.assign({}, completeParam)
            if (!opacity && !display) {
              // 把透明度重置为1
              completeParamClone.option_name = "opacity"
              completeParamClone.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeParamClone)
            }
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeParam)
            completeParamClone.option_name = "display"
            const noEmpty = completeParam.option_val !== "" && isExist(completeParam.option_val)
            completeParamClone.option_val = noEmpty ? "block" : "none"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeParamClone)
          },
          delElementCb: (ids, opacity) => {
            let completeparam = Object.assign({}, ids)
            completeparam.option_name = "display"
            completeparam.option_val = "none"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeparam)
            if (!opacity) {
              // 把透明度重置为1
              completeparam.option_name = "opacity"
              completeparam.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeparam)
            }
          },
          componentBoxUpdateCb: ({ url, dataId, uid, pageType }) => {
            const param = {
              rect_id: this.ids.rect_id,
              container_id: this.ids.container_id,
              elementInAutoLayoutId: this.layoutOptions.elementInAutoLayoutId,
              path: this.layoutOptions.path,
              uid: uid,
              option_val: url,
              option_name: "componentBoxOptions-dataUrl"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", param)

            const dataIdParam = {
              rect_id: this.ids.rect_id,
              container_id: this.ids.container_id,
              elementInAutoLayoutId: this.layoutOptions.elementInAutoLayoutId,
              path: this.layoutOptions.path,
              uid: uid,
              option_val: dataId,
              option_name: "componentBoxOptions-dataId"
            }

            const pageTypeParam = {
              rect_id: this.ids.rect_id,
              container_id: this.ids.container_id,
              elementInAutoLayoutId: this.layoutOptions.elementInAutoLayoutId,
              path: this.layoutOptions.path,
              uid: uid,
              option_val: pageType,
              option_name: "componentBoxOptions-pageType"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", pageTypeParam)

            this.$store.dispatch(this.request_prefix + "/updateColsOption", dataIdParam)
          },
          componentBoxUpdateOpacity: ({ opacity, uid }) => {
            const param = {
              rect_id: this.ids.rect_id,
              container_id: this.ids.container_id,
              elementInAutoLayoutId: this.layoutOptions.elementInAutoLayoutId,
              path: this.layoutOptions.path,
              uid: uid,
              option_val: opacity,
              option_name: "componentBoxOptions-opacity"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", param)
          },
          updateEleCb: (val, content_name, deep, deepName, ids) => {
            this.$changeOptionsEV(val, content_name, deep, deepName, ids)
          }
        })
        newCompleteData = completeData
        newDrawLayoutAlready = drawLayoutAlready
      }
      if((newCompleteData.length - 1) < activeIndex){
        activeIndex = newCompleteData.length - 1
      }
      const tempComplete = newCompleteData[activeIndex]
      this.completeData = newCompleteData[activeIndex]
      if (this.isTypeRenderMode) {
        // 渲染分类模式
        this.fieldMappingList = TYPE_FIELD_MAPPING
      } else {
        // 点击出弹窗功能，清空值
      if (this.fieldMappingClickStatus) this.fieldMappingClickStatus = ""
      if (this.fieldMappingMessage) this.fieldMappingMessage = ""
      this.fieldMappingList = []
      Object.keys(tempComplete).forEach(key => {
          if (!tempComplete[key]) return
          // 点击出弹窗功能 保存点击状态
          if (this.options.innerElement === "cxButton" || this.options.innerElement === "cxLabel") {
            if (tempComplete[key].key === "clickStatus") {
              this.fieldMappingClickStatus = key
            }
            if (tempComplete[key].key === "message") {
              this.fieldMappingMessage = key
            }
          }
        // 重新组装字段映射的数据结构
          if (key && key !== "url" && key !== "publicId" && key !== "id" && key !== "pageType" && key !== "viewNum") {
            const temp = {
              value: key,
              label: tempComplete[key]?.key
            }
            if (tempComplete[key] && tempComplete[key].key) {
              this.fieldMappingList.push(temp)
            }
          }
          if (key === "viewNum") {
            const temp = {
              value: key,
              label: "浏览量"
            }
            this.fieldMappingList.push(temp)
          }
        })
      }
      
      if (rectAttr.innerElement === "swiperComponent") {
        this.drawData(newDrawLayoutAlready, newCompleteData, updateLayoutData)
      } else {
        this.startGetUserChoose(newCompleteData, newDrawLayoutAlready, updateLayoutData)
      }
    },
    getGridFiledMapping() {
      const data = this.shareDataPool.getData(
        `gridData-${this.ids.container_id}-${this.ids.rect_id}`
      )
      if (data && data.length) {
        this.completeData = JSON.parse(data)[0]
        const tempComplete = this.completeData
        if (tempComplete) {
          // 组装字段映射的数据结构
          Object.keys(tempComplete).forEach(key => {
            if (!tempComplete[key]) return
            if (key !== "url" && key !== "publicId" && key !== "id" && key !== "pageType" && key !== "viewNum") {
              const temp = {
                value: key,
                label: tempComplete[key]?.key
              }
              if (tempComplete[key] && tempComplete[key].key) {
                this.fieldMappingList.push(temp)
              }
            }
            if (key === "viewNum") {
              const temp = {
                value: key,
                label: "浏览量"
              }
              this.fieldMappingList.push(temp)
            }
          })
        }
        this.$eventBus.$emit("subPage-component-init", {
          type: this.layoutOptions.innerElement + "_" + this.layoutOptions.businessId
        })
      }
    },
    async startGetUserChoose(completeData, drawLayoutAlready, updateLayoutData) {
      const menus =
        this.request_prefix === "bigScreen"
          ? this.$store.state.bigScreenMenu.menu.children.find(it => it.name === "基础").children
          : this.$store.state.menu.menu.children[1].children
      //数据处理
      if (drawLayoutAlready) {
        // 预先画好了布局,但没画完
        updateLayoutData.startUpdateLayout(completeData, drawLayoutAlready, menus)
      } else {
        //没有预先画好布局 是否自动生成？
        const menus =
          this.request_prefix === "bigScreen"
            ? this.$store.state.bigScreenMenu.menu.children.find(it => it.name === "基础").children
            : this.$store.state.menu.menu.children[1].children
        updateLayoutData.createLayoutComponent(completeData, null, null, menus)
      }
    },
    // 轮播根据数据绘制应用
    async drawData(drawLayoutAlready, completeData, updateData) {
      const createCb = param => {
        this.$store.dispatch(this.request_prefix + "/addComponentInSwiper", param)
      }
      const updateCb = (val, content_name, deep, deepName, ids) => {
        this.$changeOptionsEV(val, content_name, deep, deepName, ids, true)
      }
      const delSlideCb = param => {
        this.$store.dispatch(this.request_prefix + "/swiperContentControl", param)
      }
      //过滤掉数据中没用的数据和空数据，并给每个数组元素判断出需要增加的组件类型
      //轮播内组件数量和与后台数据一致性的校验
      if (drawLayoutAlready) {
        // 预先画好了布局,但没画完
        updateData.updateSwiperContent({ completeData, drawLayoutAlready, createCb, updateCb, delSlideCb })
      } else {
        updateData.updateSwiperContent({ completeData, createCb, updateCb, delSlideCb })
      }
    },
    // 改变filedMapping的值
    changeFiledMappingHandle(data, params, isGetData) {
      console.log("ininin")
      let elementInAutoLayoutId =
        this.ids.elementInAutoLayoutId !== undefined ? this.ids.elementInAutoLayoutId : params.elementInAutoLayoutId
      let path = this.ids.hasOwnProperty("path") ? this.ids.path : params.path
      let currentFiledMapping = this.filedMapping
      if (params.flag === "dataType") {
        currentFiledMapping[params.flag] = data
      } else if (params.flag === "linkUrl") {
        currentFiledMapping.linkUrl = data
      } else if (params.flag === "value") {
        currentFiledMapping.value = data
        if(data) {
          currentFiledMapping.flag = true
        }
        // 判断当前选中字段类型，如果是日期字段，则需要显示日期格式设置项
        const tempComplete = this.completeData
        tempComplete && Object.keys(tempComplete).forEach(key => {
          if (key === data) {
            currentFiledMapping.dateStyle = "1"
            if (tempComplete[key].component_shape?.includes("cxDate")) {
              currentFiledMapping.isDate = true
            } else {
              currentFiledMapping.isDate = false
            }
          }
        })
      }
      console.log("currentFiledMapping :>>", currentFiledMapping)

      this.$changeOptionsEV(currentFiledMapping, "filedMapping", false, null, this.commitIds)

      if (currentFiledMapping.value === "viewNum") {
        this.$changeOptionsEV(true, "isHasViewNum", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id,
          elementInAutoLayoutId: elementInAutoLayoutId,
          path: path
        })
      }

      if (this.isSearchListPage || this.isGroupSearchListPage) {
        this.$changeOptionsEV(currentFiledMapping, "filedMapping", false, null, this.commitIds)
        // 通知列表更新数据
        this.$eventBus.$emit(`update-layout-data-eventBus-${this.ids.container_id}-${this.ids.rect_id}`, {
          searchKey: "",
          isGroupSearch: this.isGroupSearchListPage ? true : false
        })
        return
      }

      // 手动触发一次数据响应，只有选中时查询数据，取消选择不查询
      if (isGetData && !this.isSearchListPage && !this.isGroupSearchListPage && data) {
        this.getFiledMappingList()
      }
      if (this.isCxDataGrid) {
        this.$eventBus.$emit("subPage-component-init", {
          type: this.layoutOptions.innerElement + "_" + this.layoutOptions.businessId
        })
      }
    },
    getSearchListData() {
      const { pageId } = this.$store.state.states.getDataPageIds
      let completeData = window.localStorage.getItem("searchListData-" + pageId)
      this.fieldMappingList = []
      if (completeData) {
        completeData = JSON.parse(completeData)
        let colsIdFromActiveRect = getAllColsUidInLayoutComponent([this.layoutOptions.rows[0]])
        let activeIndex = colsIdFromActiveRect.findIndex(item => item == this.ids.uid)
        if (completeData && completeData[activeIndex]) {
          // 组装字段映射的数据结构
          Object.keys(completeData[activeIndex]).forEach((key, index) => {
            if (completeData[activeIndex][key]?.label) {
              const temp = {
                value: key,
                label: completeData[activeIndex][key]?.label
              }
              this.fieldMappingList.push(temp)
            }
          })
        }
        this.completeData = completeData
      }
    },
    getGroupSearchListData() {
      const { pageId } = this.$store.state.states.getDataPageIds
      let completeData = window.localStorage.getItem("groupSearchListData-" + pageId)
      this.fieldMappingList = []
      if (completeData) {
        completeData = JSON.parse(completeData)
        let colsIdFromActiveRect = getAllColsUidInLayoutComponent([this.layoutOptions.rows[0]])
        let activeIndex = colsIdFromActiveRect.findIndex(item => item == this.ids.uid)
        if (completeData && completeData[activeIndex]) {
          // 组装字段映射的数据结构
          Object.keys(completeData[activeIndex]).forEach((key, index) => {
            if (completeData[activeIndex][key]?.label) {
              const temp = {
                value: key,
                label: completeData[activeIndex][key]?.label
              }
              this.fieldMappingList.push(temp)
            }
          })
        }
        this.completeData = completeData
      }
    },
    onChangeMappingType(value) {
      this.fieldMappingDataType = value
      this.getFiledMappingList()
    },
    onChangeMappingDateStyle(value) {
      this.filedMapping.dateStyle = value
      this.getFiledMappingList()
    },
    onChangeMappingDateTitle() {
      this.getFiledMappingList()
    }
  }
}
</script>

<style scoped lang="scss">
.mapping_content {
  padding: 8px;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background-color: rgba(247, 248, 250, 1);
  &.checked,
  &:hover {
    border: 1px solid rgba(36, 0, 255, 0.16);
    background-color: rgba(36, 0, 255, 0.04);
  }
  .content-title {
    height: 18px;
    line-height: 18px;
    font-size: 13px;
  }
  .select_content {
    ::v-deep .el-input__inner {
      font-size: 13px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 0px 1px rgba(233, 233, 233, 1) inset;
    }
  }
  &.checked {
    .select_content {
      ::v-deep .el-input__inner {
        font-size: 13px;
        background-color: rgba(36, 0, 255, 0.1);
        color: rgba(36, 0, 255, 1);
        box-shadow: 0px 0px 0px 1px rgba(36, 0, 255, 0.16) inset;
        &:hover {
          background-color: rgba(36, 0, 255, 0.2);
        }
      }
      ::v-deep .el-select__caret {
        color: rgba(36, 0, 255, 1);
      }
      ::v-deep .is-focus .el-input__inner {
        background-color: rgba(36, 0, 255, 0.2);
      }
    }
  }
  .mapping_date_content {
    height: 20px;
    .date-label {
      font-size: 13px;
      color: var(--thirdTextColor);
      margin-right: 4px;
    }
    ::v-deep .el-dropdown {
      font-size: 13px;
    }
  }
  .el-checkbox {
    margin-right: 4px;
  }
  .vedio-style {
    font-size: 13px;
  }
}
.text_content {
  background: var(--inputArrowBgColor);
  border: 1px solid var(--borderColorTen);
  border-radius: 4px;
  padding: 8px;
  color: var(--elCollapseItemContentColor);
  &:not(:last-child) {
    margin-bottom: 8px;
  }
  &:hover {
    background: var(--themeColorSelectBg);
  }
  .el-checkbox {
    margin-right: 4px;
  }
  ::v-deep .el-input .el-input__inner {
    background-color: var(--leftMenuBgColor);
  }
}
.custom-dropdown {
  .dropdown-title-show {
    padding: 7px 12px;
    border-bottom: 1px solid rgba(233, 233, 233, 1);
    ::v-deep .el-checkbox__label {
      font-size: 13px;
    }
  }
  ::v-deep .el-dropdown-menu__item {
    height: 34px;
    line-height: 34px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.8);
    .active {
      color: rgba(43, 103, 255, 1);
    }
  }
}
.bigScreen {
  .mapping_content {
    color: rgba(255, 255, 255, 0.8);
    border-color: rgba(255, 255, 255, 0.08);
    background-color: rgba(40, 42, 46, 1);
    &.checked,
    &:hover {
      border-color: rgba(166, 139, 255, 0.16);
      background-color: rgba(166, 139, 255, 0.04);
    }
    .select_content {
      ::v-deep .el-input__inner {
        background-color: rgba(31, 33, 36, 1);
        box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.08) inset;
      }
    }
    &.checked {
      .select_content {
        ::v-deep .el-input__inner {
          background-color: rgba(166, 139, 255, 0.1);
          color: rgba(166, 139, 255, 1);
          box-shadow: 0px 0px 0px 1px rgba(166, 139, 255, 0.16) inset;
          &:hover {
            background-color: rgba(166, 139, 255, 0.2);
          }
        }
        ::v-deep .el-select__caret {
          color: rgba(166, 139, 255, 1);
        }
        ::v-deep .is-focus .el-input__inner {
          background-color: rgba(166, 139, 255, 0.2);
        }
      }
    }
  }
}
.custom-dropdown.bigScreen {
  .dropdown-title-show {
    border-color: rgba(55, 55, 55, 1);
  }
  ::v-deep .el-dropdown-menu__item {
    color: rgba(255, 255, 255, 0.8);
    .active {
      color: rgba(43, 103, 255, 1);
    }
  }
}
.verticallyBetweenCenter {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
